import { createResource } from 'redux-rest-resource';
import { HEADERS as headers, ACTIVITIES_URL } from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'activity',
  pluralName: 'activities',
  url: `${ACTIVITIES_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
